/**
 * RENDA-K の配色。
 *
 * スプラトゥーン風のポップなインクカラー + SOREMO ブランドカラー
 * （soremo_style.scss の --soremo-blue / --soremo-green と同値）。
 * ノブキャップにはブランドカラーを優先して使う。
 * パネルはクリーム地 + 濃紺の太い縁取りで、ステッカー/トイガンの
 * 世界観にする（PHRASE BLOOM の Neve 風パネルとは別系統）。
 */

export const RENDA_COLORS = {
  /** SOREMO ブランド（--soremo-blue） */
  soremoBlue: "#009ace",
  /** SOREMO ブランド（--soremo-green） */
  soremoGreen: "#2cc84d",
  inkPink: "#f0327d",
  inkLime: "#b8e021",
  inkOrange: "#ff8c1a",
  inkPurple: "#7a4de8",
  inkYellow: "#ffd21f",
  inkCyan: "#22c7e6",
} as const;

export const RENDA_PANEL = {
  face: "#fffbef",
  faceEdge: "#f3ecd6",
  /** 濃紺の太縁取り（スプラ風ステッカーのアウトライン） */
  outline: "#252a40",
  border: "#3a4160",
  sectionBorder: "rgba(37, 42, 64, 0.35)",
  engraving: "rgba(37, 42, 64, 0.72)",
  engravingStrong: "#252a40",
  displayBg: "#1c2135",
  displayText: "#eef7ff",
  /** クリーム地の目盛り・非アクティブ要素 */
  tick: "rgba(37, 42, 64, 0.32)",
  /** フォーカスリング（ブランドブルー） */
  focus: "rgba(0, 154, 206, 0.8)",
} as const;

/** パネル刻印用フォント（Typekit で読込済み、PHRASE BLOOM と共通） */
export const RENDA_FONT = '"din-2014", sans-serif';
